<script>

export default {
  name: 'alert-no-covenant'
}
</script>

<template lang="pug">
  .alert.alert-danger.alert-dismissable.fade.in(style="color: red")
    button.close(type='button', data-dismiss='alert', aria-label='close')
      span(aria-hidden='true') ×
    strong
    | Você não possui nenhum convênio cadastrado. Favor selecionar  &nbsp;
    strong Particular  &nbsp;
    | para agendar sua consulta.
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/form/components/alert/alert-no-covenant.vue